"use client";

import { ArrowRight, Mouse } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MeesterlijkeSnitInMiddelharnis() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="80661" id="meesters-in-fades-klassieke-stijlen" className="dark bg-background text-foreground relative h-screen min-h-[600px] w-full flex items-start overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/barber_precision_fade_cinematic.png')]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-black/60" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_10%,rgba(0,0,0,0.9)_100%)]" />

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6 lg:px-8">
        <div ref={ref} className={`max-w-4xl transition-all duration-1000 ease-out transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <h1 className="flex flex-col gap-2 md:gap-4 mb-10">
            <span className="font-sans font-extrabold uppercase text-white text-4xl md:text-6xl lg:text-7xl tracking-tighter drop-shadow-2xl">
              MEESTERS IN OVERLOPEN
            </span>
            <span className="font-sans font-bold uppercase text-primary text-xl md:text-3xl lg:text-4xl tracking-widest drop-shadow-lg">
              Sinds 2010 in Middelharnis
            </span>
          </h1>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 mt-12">
            <Button size="lg" asChild className="text-lg px-10 py-7 rounded-sm bg-primary text-primary-foreground border border-primary hover:shadow-[0_0_30px_rgba(212,175,55,0.5)] transition-all duration-300 font-bold uppercase tracking-wider">
              <Link to="https://salonkee.nl/salon/he-kappers">Maak een afspraak</Link>
            </Button>
            
            <Link to="/RatesPage" className="group flex items-center gap-3 text-lg font-bold uppercase tracking-wider text-white hover:text-primary transition-colors duration-300">
              Bekijk diensten
              <ArrowRight className="size-6 text-primary transition-transform duration-300 group-hover:translate-x-2" />
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce opacity-60">
        <div className="w-[2px] h-16 bg-gradient-to-b from-primary/50 to-transparent" />
        <Mouse className="size-6 text-primary" />
        <span className="text-[10px] uppercase tracking-[0.3em] text-primary/70 font-sans font-bold">
          Scrollen
        </span>
      </div>
    </section>;
}